module.exports = __webpack_public_path__ + "static/img/Elias_Hammet_IMG.6111e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Desktop/Home_Landing/Elias_Hammet_IMG.png
// module id = ipmQ
// module chunks = 0